import { Routes } from '@angular/router';
import { LoginComponent } from './containers/login/login.component';
import { ResetPasswordComponent } from './containers/reset-password/reset-password.component';
import { SendEmailComponent } from './containers/send-email/send-email.component';
import { WrapperComponent } from './containers/wrapper/wrapper.component';
import { AuthGuard } from './guards/auth.guard';
import { ResetPasswordGuard } from './guards/reset-password.guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: WrapperComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'send-reset-email',
        component: SendEmailComponent,
      },
      {
        path: 'reset/:token/:username',
        component: ResetPasswordComponent,
        canActivate: [ResetPasswordGuard],
      },
    ],
  },
];
